import LanguageEnum from "../../enums/language.enum";
import React from "react";
import LabeledSelect from "../labeledselect/labeledselect";

interface ILanguageSelector {
  selectedLanguage: LanguageEnum;
  handleLanguageSelect: (arg: number) => void;
}

const languagesValues = Object.keys(LanguageEnum)
  .filter((key) => !isNaN(Number(key)))
  .map((key) => ({
    id: key,
    name: LanguageEnum[key]
  }));

const getSelectedLanguage = (selectedLanguage) => {
  let res = selectedLanguage;
  if (isNaN(selectedLanguage)) {
    res = LanguageEnum[selectedLanguage as unknown as keyof typeof LanguageEnum];
  }
  return languagesValues[res]?.id || languagesValues[0].id;
};

const LanguageSelector = (props: ILanguageSelector) => {
  return (
    <LabeledSelect
      testid="dropdown-link-player-language-select"
      style={{ width: "130px" }}
      label="Language"
      options={languagesValues}
      selected={getSelectedLanguage(props.selectedLanguage)}
      onOptionSelected={(selectedLanguageId) => {
        const selectedLanguage = LanguageEnum[selectedLanguageId] as unknown as LanguageEnum;
        props.handleLanguageSelect(selectedLanguage);
      }}
    />
  );
};
export default LanguageSelector;
